import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import {
  renderPriceWithCurrency,
  renderPriceWithCurrencyWithoutUnit,
  addSpace,
} from "@utils/utils";
import { GridRow, GridSubItem, GridSubLabel } from "../../QuoteView.styled";

import { GridItem, HorizontalRow, FlexRow } from "./QuoteServices.styled";

const QuoteItems = (props) => {
  const {
    t,
    itemList,
    enquiryId,
    sellingPriceId,
    currency,
    getConvertedPrice,
    mainCurrency,
    serviceStatus,
  } = props;

  return (
    <>
      {itemList?.length > 0 &&
        itemList.map((item, itemIndex) => {
          return (
            <React.Fragment key={"quote-item" + item?.id + itemIndex}>
              {itemIndex !== 0 && <HorizontalRow />}

              <GridRow
                column="60% 12% 13% 15%"
                marginBottom="0px"
                gridGap="0rem"
                marginTop="0px"
              >
                <GridItem backgroundColor={serviceStatus ? "#fff" : "#D9D9D9"}>
                  <FlexRow
                    column="auto 1fr"
                    marginBottom="0px"
                    gridGap=".50rem"
                    marginTop="0px"
                  >
                    <GridSubLabel>{String(item?.label) || ""}</GridSubLabel>
                    <GridSubItem>
                      {item.hesusService.needProduct && item.product.name}
                      {item.hesusService.needProduct &&
                        item.hesusService.needTransport &&
                        " - "}
                      {item.hesusService.needTransport && item.transport.name}
                    </GridSubItem>
                  </FlexRow>
                  {item?.comment && (
                    <GridRow column="1fr" marginBottom="0px">
                      <GridSubItem color="#474747">{item?.comment}</GridSubItem>
                    </GridRow>
                  )}
                </GridItem>
                <GridItem backgroundColor={serviceStatus ? "#fff" : "#D9D9D9"}>
                  {item.quantity + " " + t(item?.unit)}
                </GridItem>
                <GridItem backgroundColor={serviceStatus ? "#fff" : "#D9D9D9"}>
                  {parseInt(mainCurrency.id, 10) !==
                    parseInt(currency?.id, 10) && (
                    <>
                      <GridSubItem
                        color="#474747"
                        fontSize="16px"
                        fontWeight="400"
                        textAlign="center"
                        fontStyle="normal"
                      >
                        {renderPriceWithCurrency(
                          addSpace(
                            getConvertedPrice(
                              currency?.id,
                              item?.itemSellingPrice
                            )
                          ),
                          t(item?.unit),
                          mainCurrency?.symbol,
                          mainCurrency?.position
                        )}
                      </GridSubItem>
                      <GridSubItem
                        color="#767676"
                        fontSize="16px"
                        textAlign="center"
                      >
                        {renderPriceWithCurrency(
                          addSpace(item?.itemSellingPrice),
                          t(item?.unit),
                          currency?.symbol,
                          currency?.position
                        )}
                      </GridSubItem>
                    </>
                  )}
                  {parseInt(mainCurrency.id, 10) ===
                    parseInt(currency?.id, 10) &&
                    renderPriceWithCurrency(
                      addSpace(item?.itemSellingPrice),
                      t(item?.unit),
                      currency?.symbol,
                      currency?.position
                    )}
                </GridItem>

                <GridItem
                  backgroundColor={serviceStatus ? "#e2edf6" : "#D9D9D9"}
                  textAlign="right"
                  fontWeight="700"
                  borderRight="0px solid rgba(10, 73, 134, 0.3)"
                >
                  {parseInt(mainCurrency.id, 10) !==
                    parseInt(currency?.id, 10) && (
                    <>
                      <GridSubItem
                        color="#474747"
                        fontSize="16px"
                        fontWeight="700"
                        textAlign="right"
                        fontStyle="normal"
                      >
                        {renderPriceWithCurrencyWithoutUnit(
                          addSpace(
                            getConvertedPrice(
                              currency?.id,
                              (item?.itemSellingPrice ?? 0) *
                                (item.quantity ?? 0)
                            )
                          ),
                          mainCurrency?.symbol,
                          mainCurrency?.position
                        )}
                      </GridSubItem>
                      <GridSubItem
                        color="#767676"
                        fontSize="16px"
                        textAlign="right"
                      >
                        {renderPriceWithCurrencyWithoutUnit(
                          addSpace(
                            (item?.itemSellingPrice ?? 0) * (item.quantity ?? 0)
                          ),
                          currency?.symbol,
                          currency?.position
                        )}
                      </GridSubItem>
                    </>
                  )}
                  {parseInt(mainCurrency.id, 10) ===
                    parseInt(currency?.id, 10) &&
                    renderPriceWithCurrencyWithoutUnit(
                      addSpace(
                        getConvertedPrice(
                          currency?.id,
                          (item?.itemSellingPrice ?? 0) * (item.quantity ?? 0)
                        )
                      ),
                      currency?.symbol,
                      currency?.position
                    )}
                </GridItem>
              </GridRow>
            </React.Fragment>
          );
        })}
    </>
  );
};

QuoteItems.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.number,
};
QuoteItems.defaultProps = {
  id: null,
};

export default withTranslation()(QuoteItems);
